export default __webpack_public_path__ + "static/landing-1aad3917273e9ab16c391604883763f6.svg";